import {BaseData} from '../../base/static_config_data/BaseData';
import {CardDataEvent} from './card_data/CardDataEvent';
import {ActiveData} from '../../../ActiveData';

export class CardData extends BaseData
{

    constructor(public config: ICardData | null = null) {
        super();
    }

    get title(): string {
        return this.config!.title;
    }

    set title(value: string) {
        this.config!.title = value;
        ActiveData.addEventToPool<string>(this, CardDataEvent.TITLE_CHANGED, this.config!.title);
    }

    get id(): number {
        return this.config!.id;
    }

    set id(value: number) {
        this.config!.id = value;
        ActiveData.addEventToPool<number>(this, CardDataEvent.ID_CHANGED, this.config!.id);
    }

    get backfacePaint(): string {
        return this.config!.backfacePaint;
    }

    set backfacePaint(value: string) {
        this.config!.backfacePaint = value;
        ActiveData.addEventToPool<string>(this, CardDataEvent.BACKFACE_PAINT_CHANGED, this.config!.backfacePaint);
    }

    get backface_src(): string {
        return this.config!.backface_src;
    }

    set backface_src(value: string) {
        this.config!.backface_src = value;
        ActiveData.addEventToPool<string>(this, CardDataEvent.BACKFACE_SRC_CHANGED, this.config!.backface_src);
    }

    get face_src(): string {
        return this.config!.face_src;
    }

    set face_src(value: string) {
        this.config!.face_src = value;
        ActiveData.addEventToPool<string>(this, CardDataEvent.FACE_SRC_CHANGED, this.config!.face_src);
    }

    get flipped(): boolean {
        return this.config!.flipped;
    }

    set flipped(value: boolean) {
        this.config!.flipped = value;
        ActiveData.addEventToPool<boolean>(this, CardDataEvent.FLIPPED_CHANGED, this.config!.flipped);
    }

    get width(): number {
        return this.config!.width;
    }

    set width(value: number) {
        this.config!.width = value;
        ActiveData.addEventToPool<number>(this, CardDataEvent.WIDTH_CHANGED, this.config!.width);
    }

    get height(): number {
        return this.config!.height;
    }

    set height(value: number) {
        this.config!.height = value;
        ActiveData.addEventToPool<number>(this, CardDataEvent.HEIGHT_CHANGED, this.config!.height);
    }

    get metaType(): MetaType {
        return this.config!.metaType;
    }

    set metaType(value: MetaType) {
        this.config!.metaType = value;
        ActiveData.addEventToPool<MetaType>(this, CardDataEvent.META_TYPE_CHANGED, this.config!.metaType);
    }

    get paint(): string {
        return this.config!.paint;
    }

    set paint(value: string) {
        this.config!.paint = value;
        ActiveData.addEventToPool<string>(this, CardDataEvent.PAINT_CHANGED, this.config!.paint);
    }

    get selected(): boolean {
        return this.config!.selected;
    }

    set selected(value: boolean) {
        this.config!.selected = value;
        ActiveData.addEventToPool<boolean>(this, CardDataEvent.SELECTED_CHANGED, this.config!.selected);
    }

    get type(): CardType {
        return this.config!.type;
    }

    set type(value: CardType) {
        this.config!.type = value;
        ActiveData.addEventToPool<CardType>(this, CardDataEvent.TYPE_CHANGED, this.config!.type);
    }

    get zIndex(): number {
        return this.config!.zIndex;
    }

    set zIndex(value: number) {
        this.config!.zIndex = value;
        ActiveData.addEventToPool<number>(this, CardDataEvent.Z_INDEX_CHANGED, this.config!.zIndex);
    }
}

export interface ICardData
{
    backfacePaint: string;
    backface_src: string;
    face_src: string;
    flipped: boolean;
    height: number;
    id: number;
    metaType: MetaType;
    paint: string;
    selected: boolean;
    title: string;
    type: CardType;
    width: number;
    zIndex: number;
}

export enum CardType
{
    NORMAL = 1,
    RANDOM
}

export enum MetaType
{
    PLAY = 'play',
    TRAP = 'trap',
    NONE = ''
}
